<template>
  <div>
    <div style="height:54px;" class="comm-settings-top-nav">
      <div class="justify-content-start" style="position: relative;display: inline-block;width: 100%;height: 100%;">
        <!-- <back-button v-if="componentname != 'show-installed-plugins'" v-on:click.native="changeSelectedPluginComponent('show-installed-plugins')" style="position: absolute;bottom: 7px;inset-inline-start:5px;"></back-button> -->
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb comm-settings-top-nav m-0" style="padding-inline-start:1%;align-items: center;">
            <li><back-button v-if="componentname != 'show-installed-plugins'" v-on:click.native="changeSelectedPluginComponent('show-installed-plugins')" class="comm-icon-rtl" style="position:relative;bottom:0px"></back-button></li>
            <!-- <li class="breadcrumb-item"><a v-on:click="changeSelectedPluginComponent('show-installed-plugins')">Plugins</a></li> -->
            <li class="breadcrumb-item active-text-nav-bar" aria-current="page">{{pluginInfo.plugin_name}}</li>
            </ol>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>

import BackButton from "../core/backButton.vue";

export default {
    props:["pluginInfo","componentname"],
    data(){
        return{
            add:"Add",
        }
    },
    components:{
        "back-button":BackButton
    },
    methods:{
        changeSelectedPluginComponent(compName, payload = {}){
            this.$emit("changeSelectedPluginComponent", compName, payload)
        },
        openAddPluginsWindow(){
            this.$emit("openAddPlugins")
        }
    },
}
</script>

<style scoped lang="scss">
    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $danger-color: #dc3545 !important;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $metadata-border-color-on-hover: #5a5a5a;
    $secondary-border-color: 1px solid #2b2b2b;
    $active-green-color:#28a745;
    $svg-color:#666;
    $learn-about-text-color-hover:#b7b327;
    $active-green-icon-color: #00ff3a;
    $learn-about-text-color:#9a9620;


.comm-settings-top-nav{
    background: $primary-background !important;
}

.btn{
    font-size:14px !important;
    height:100%;
}

.breadcrumb{
    padding: 8px 10px !important;
    .active-text-nav-bar{
        color: $text-color !important;
        text-decoration: none !important
    }
    .active-text-nav-bar:last-child{
            color: $active-blue !important;
            font-size:17px;
    }
    .breadcrumb-item{
        a{
            color: $text-color;
            font-weight:600;
        }
        a:hover{
            text-decoration: underline;
        }
    }    
}

.primary-btn-style{
    margin-top:1%;
    button{
        height: 35px;
        width: 70px;
    }
}
</style>